import React, { Component } from "react";
import { Form, Button, Card, Alert } from "react-bootstrap";
import axios from "axios";
import CommonToast from "../Toaster/CommonToast";

export default class ProfileImageUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profileImage: null,
      uploading: false,
      previewUrl: null,
      displayUploadedImage: '',
      uploadingStatus: '',
      completed: '',
      hasError: "",
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: '',
    };
  }


  componentDidMount() {
    const { userId } = this.props;
    this.fetchEmployeeProfile(userId)
  }

  fetchEmployeeProfile = (id) => {
    axios({
      method: 'get',
      url: `document/profile/${id}`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        this.setState({
          displayUploadedImage: res.data.profileImage
        })
      })
      .catch(err => {
        console.log("error is here", err)
      })
  }



  handleImageChange = (event) => {
    const file = event.target.files[0];
    this.setState({ profileImage: file, previewUrl: URL.createObjectURL(file) });
  };

  uploadProfileImage = async () => {
    //debugger
    const { userId } = this.props;
    const { profileImage } = this.state;
    if (!userId || !profileImage) return;
    const formData = new FormData();
    formData.append("document", profileImage);
    formData.append("type", "p")
    try {
      this.setState({ uploading: true });
      const res = await axios.post(`document/upload/profile/${userId}`, formData);
      console.log("res?.data?.message===========>", res?.data?.message);
      this.setState({
        uploadingStatus: res?.data?.message,
        completed: true,
        toastMessage: res?.data?.message,
        toastVariant: 'success',
        color: 'green',
        showToast: true,
      })
      // alert("Profile Image uploaded successfully!");
      this.fetchEmployeeProfile(userId)
    } catch (error) {
      this.setState({
        uploadingStatus: "Profile Image Upload Failed due to no Face",
        hasError: true,
        toastMessage: "Profile Image Upload Failed due to no Face",
        toastVariant: 'danger',
        color: 'red',
        showToast: true,
      })
    } finally {
      this.setState({ uploading: false });
    }
  };

  render() {
    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />

        <div className="row">
          {/* {this.state.hasError ? (
            <Alert variant="outline-danger" className="m-3" block>
              {this.state.uploadingStatus}
            </Alert>
          ) : this.state.completed ? (
            <Alert variant="outline-success" className="m-3" block>
              {this.state.uploadingStatus}
            </Alert>
          ) : (
            <></>
          )} */}
        </div>
        <Card className="mb-3">

          <Card.Body>
            <Form.Group>
              <Form.Label>Profile Image </Form.Label>
              <span className="warning-image">(Only upload face image in JPEG and JPG format) </span>
              <Form.Control type="file" accept="image/*" onChange={this.handleImageChange} />
              <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary mt-2" onClick={this.uploadProfileImage} disabled={this.state.uploading}>
                {this.state.uploading ? "Uploading..." : "Upload Profile Image"}
              </Button>

            </Form.Group>
            {/* {
              this.state.previewUrl && (
                <div className="mt-3">
                  <img alt="profile_broken" src={process.env.PUBLIC_URL + this.state.previewUrl} width="200" height="200" type="application/pdf" />
                </div>
              )
            } */}
          </Card.Body >
          <div>
            {this.state.displayUploadedImage && (
              <div className="image-container">
                <img
                  className="profile-image"
                  src={`${process.env.REACT_APP_BACKEND_URL}/${this.state.displayUploadedImage}`}
                  alt="Profile"
                />
              </div>
            )}
          </div>
        </Card >
      </>
    );
  }
}
